<template>
  <div>
    <BaseButton type="button" ghost small class="flex items-center" @click="deleteAudience">
      <span>Delete</span>
    </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    audience: {
      type: Object,
      required: true,
    },
    onDeleted: {
      type: Function,
      default: () => {
        //
      },
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    deleteAudience() {
      this.$modal.show({
        component: () => import('Components/Audience/AudienceDeleteModal.vue'),
        props: {
          audienceId: this.audience.id,
        },
        on: {
          destroyed: this.onDeleted,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
